var websiteRegex = /^((http|https):\/\/)?[\w-]+([-.]{1}[\w-]+)*\.[a-z]{2,}([/]{1})?$/i;
export default websiteRegex;